import { render, staticRenderFns } from "./ProfileMenuRegionTeam.vue?vue&type=template&id=80d0c9d2&scoped=true&"
import script from "./ProfileMenuRegionTeam.vue?vue&type=script&lang=js&"
export * from "./ProfileMenuRegionTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d0c9d2",
  null
  
)

export default component.exports